import { AnalysisConfig } from "../models/AnalysisConfig";
import { AnalysisConfigField } from "../models/AnalysisConfigField";
import { AnalysisConfigSchema } from "../models/AnalysisConfigSchema";

export class AnalysisConfigTypeGuardService {

    private static readonly ANALYSISCONFIG_TYPES_THAT_SUPPORT_CHILD_RULES: string[] = [];

    public static isAnalysisConfig(obj: unknown): obj is AnalysisConfig {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            '_type' in obj &&
            typeof (obj as any)._type === 'string'
        );
    }

    public static isAnalysisConfigField(obj: unknown): obj is AnalysisConfigField {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'name' in obj &&
            'field_type' in obj &&
            typeof (obj as any).name === 'string' &&
            typeof (obj as any).field_type === 'string'
        );
    }

    public static isAnalysisConfigSchema(obj: unknown): obj is AnalysisConfigSchema {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'type' in obj &&
            'display_name' in obj &&
            'fields' in obj &&
            typeof (obj as any).type === 'string' &&
            typeof (obj as any).display_name === 'string' &&
            Array.isArray((obj as any).fields)
        );
    }

    public static hasDefinedAnalysisConfigSchemaUi(analysisConfigSchema: AnalysisConfigSchema): boolean {
        return this.isAnalysisConfigSchema(analysisConfigSchema)
            && analysisConfigSchema.ui != null
            && typeof analysisConfigSchema.ui === 'object'
            && Array.isArray(analysisConfigSchema.ui.field_groups)
            && analysisConfigSchema.ui.field_groups.length > 0
            && analysisConfigSchema.ui.field_groups.every(group =>
                group != null
                && typeof group === 'object'
                && Array.isArray(group.fields)
                && group.fields.length > 0
            );
    }

    public static supportsChildAnalysisConfigs(obj: unknown): boolean {

        // any AnalysisConfigField with item_schema or payload_template
        // Note that we currently do not support payload_templates for analysis configs
        return (this.isAnalysisConfig(obj) && this.analysisConfigTypeSupportsChildAnalysisConfigs((obj as AnalysisConfig)._type))
            || (this.isPayloadTemplateAnalysisConfigSchema(obj)  //TODO: make this recursive
                && this.analysisConfigTypeSupportsChildAnalysisConfigs((obj as AnalysisConfigSchema).payload_template?.type));

    }

    public static isPayloadTemplateAnalysisConfigSchema(obj: unknown): boolean {
        return this.isAnalysisConfigSchema(obj) && (obj as AnalysisConfigSchema).payload_template != null;
    }

    public static analysisConfigTypeSupportsChildAnalysisConfigs(configType?: string): boolean {
        return this.ANALYSISCONFIG_TYPES_THAT_SUPPORT_CHILD_RULES.find(x => configType === x) != null;
    }

    public static isNonEmptyAnalysisConfigObject(value: unknown): value is Record<string, unknown> {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            Object.keys(value).length > 0
        )
    }

}
